import { motion } from "framer-motion";
import { useLang } from "../../lib/lang";
import { MATERIALS } from "../../lib/content";
import { SectionHead, EASE } from "./Reveal";

const Bar = ({ v, color }) => (
  <div className="flex gap-1">
    {[1, 2, 3, 4, 5].map((n) => (
      <motion.span key={n} initial={{ scaleY: 0.2, opacity: 0.3 }} whileInView={{ scaleY: 1, opacity: 1 }} viewport={{ once: true }} transition={{ delay: n * 0.06, duration: 0.5 }}
        className="w-3 h-5 rounded-sm origin-bottom" style={{ background: n <= v ? color : "rgba(255,255,255,0.1)" }} />
    ))}
  </div>
);

export const Materials = () => {
  const { t, lang } = useLang();
  return (
    <section id="materials" className="mx-auto max-w-[1400px] px-5 lg:px-10 py-24 lg:py-36">
      <SectionHead eyebrow={t.materialsEyebrow} title={t.materialsTitle} testid="materials-title" />
      <div className="hidden md:grid grid-cols-12 gap-4 px-6 pb-4 font-mono text-xs uppercase tracking-widest text-slate-400 border-b border-white/10">
        <span className="col-span-2">Material</span>
        {t.matCols.map((c, i) => <span key={c} className={i === 3 ? "col-span-4" : "col-span-2"}>{c}</span>)}
      </div>
      {MATERIALS.map((m, i) => (
        <motion.div
          key={m.name}
          data-testid={`material-row-${m.name.toLowerCase().replace("+", "plus")}`}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.15 }}
          transition={{ duration: 0.6, delay: i * 0.06, ease: EASE }}
          className="group grid grid-cols-2 md:grid-cols-12 gap-4 items-center px-6 py-6 border-b border-white/10 hover:bg-white/[0.03] transition-colors duration-300"
        >
          <span className="col-span-2 font-display text-3xl text-white group-hover:text-sky-300 transition-colors duration-300">{m.name}</span>
          <div className="md:col-span-2 flex md:block items-center justify-end gap-3"><span className="md:hidden font-mono text-[11px] text-slate-400">{t.matCols[0]}</span><Bar v={m.strength} color="#FF2E4D" /></div>
          <div className="md:col-span-2 flex md:block items-center gap-3"><span className="md:hidden font-mono text-[11px] text-slate-400 w-20">{t.matCols[1]}</span><Bar v={m.flex} color="#22C55E" /></div>
          <div className="md:col-span-2 flex md:block items-center justify-end gap-3"><span className="md:hidden font-mono text-[11px] text-slate-400">{t.matCols[2]}</span><Bar v={m.detail} color="#8B5CF6" /></div>
          <span className="col-span-2 md:col-span-4 text-slate-300">{m.use[lang]}</span>
        </motion.div>
      ))}
    </section>
  );
};
